module.exports = __webpack_public_path__ + "static/media/logo_white.79d4a44b.png";